module.exports = {
      id: "online-news-usage",
      viewBox: "0 0 56.84 35.647",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#online-news",
      toString: function () {
        return this.url;
      }
    }